<template>
  <el-dialog
    class="order-test related-tests-dialog"
    title=""
    :show-close="false"
    modal-class="why-calculated-dialog"
    v-model="isVisible"
    @close="close"
  >
    <template #header>
      <div class="flex justify-between items-center px-6 py-4 bg-[#004879] text-white rounded-t-[10px]">
        <span class="font-semibold text-[20px] leading-normal">Why calculate revenue</span>
        <button class="bg-transparent border-none p-0 cursor-pointer w-7 h-7" @click="close">
          <img src="@/assets/MyPatient/close.svg" alt="Close" class="w-full h-full" />
        </button>
      </div>
    </template>
    <div class="mt-4 mx-auto pb-6 dialog-container">
      <div >
        <p class="mb-4">
          {{ text1 }}
        </p>
        <div class="mb-6 py-5 px-4">
          <p ><span class="bold">{{ name + ":" }}</span> Didn't set Revenue</p>
          <p class="mt-4" v-for="(testName, index) in testNameList" :key="index">
            <span class="bold">{{ testName + ":"}}</span>
            <span>{{
                testMarkupPriceList && testMarkupPriceList[index]
                ? currency.symbol + testMarkupPriceList[index].toFixed(2)
                : ''
              }}
            </span>
          </p>
        </div>
        <p class="mb-12">
          {{ text2 }}
        </p>
      </div>
      <div class="flex justify-end mt-12">
        <LoginButton 
          type="info"
          @click="close" 
          class="w-24 mr-5"
          style="border: 1px solid #E6E6E6;"
        >
          Cancel
        </LoginButton>
        <LoginButton 
          type="primary" 
          class="w-56" 
          @click="saveMarkupAsDefault"
          :loading="isLoading"
        >
          Set default revenue
        </LoginButton>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import LoginButton from "@/views/login/components/LoginButton.vue";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    LoginButton,
  },

  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: ""
    },
    markupPrice: {
      type: Number,
      default: 0
    },
    testNameList: {
      type: Array,
      default: () => []
    },
    testMarkupPriceList: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      isVisible: false,
      isLoading: false
    }
  },

  emits: ["close", "saveMarkupAsDefault"],

  computed: {
    ...mapState(["currency"]),
    text1() {
      return "We calculated a " + this.currency.symbol + this.markupPrice.toFixed(2) + 
        " Revenue for " + this.name + " Because You didn't set a revenue for " +
        this.name + " but has a revenue for its sub test. We assume you still want to set a revenue for " +
        this.name + " but didn't get a chance to do so."
    },

    text2() {
      return "To avoid this in the future, you can set a revenue for " + this.name +
        ". The revenue can be “No Price Update”, and we will no longer calculate revenue based on sub products for you."
    }
  },

  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    }
  },

  methods: {
    close() {
      this.$emit("close");
    }, 
    saveMarkupAsDefault() {
      this.$emit("saveMarkupAsDefault");
      this.$emit("close");
    } 
  }
}
</script>

<style>
.why-calculated-dialog .el-dialog {
  border-radius: 10px;
  --el-dialog-padding-primary: 0px !important;
}
.why-calculated-dialog .el-dialog__header {
  padding: 0;
  border-bottom: none;
}
.why-calculated-dialog .el-dialog__body {
  padding: 0;
}
</style>

<style scoped>
.dialog-container {
  width: 568px;
}

p {
  word-break: break-word;
  white-space: normal;
}

.bold {
  font-weight: 500;
}
.dialog-container :deep(.btn-primary),
.dialog-container :deep(.btn-primary:hover) {
  border-color: #004879 !important;
  background: #004879 !important;
}
</style>